import { FormFieldDTO, FormFieldSelectOptionDTO, SelectFormFieldDTO } from './FormDTO';

export type FormFieldConstraint = {
    isRequired?: boolean;
    minLength?: number;
    maxLength?: number;
    minValue?: number;
    maxValue?: number;
    regex?: {
        mandatory?: RegExp;
        forbidden?: RegExp;
    };
};

export enum FormFieldType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    BOOLEAN = 'BOOLEAN',
    SELECT = 'SELECT',
}

export type BaseField<T extends FormFieldType> = FormFieldConstraint & {
    id: string;
    type: T;
    defaultValue?: string;
};

export type TextFormField = BaseField<FormFieldType.TEXT>;
export type NumberFormField = BaseField<FormFieldType.NUMBER>;
export type BooleanFormField = BaseField<FormFieldType.BOOLEAN>;

type FormFieldSelectOption = {
    label: string;
    value: string;
    selected?: boolean;
};

export type SelectFormField = BaseField<FormFieldType.SELECT> & {
    options: FormFieldSelectOption[];
};

export type FormFieldValue = TextFormField | NumberFormField | BooleanFormField | SelectFormField;

export const isSelectField = (field: BaseField<FormFieldType> | SelectFormField): field is SelectFormField => {
    return field.type === FormFieldType.SELECT;
};

const mapFormFieldSelectOption = (dto: FormFieldSelectOptionDTO): FormFieldSelectOption => {
    return {
        value: dto.value,
        label: dto.label,
        selected: dto.selected,
    };
};

export const mapBaseFormField = (dto: FormFieldDTO): BaseField<FormFieldType> => {
    return {
        id: dto.id,
        type: dto.type,
        defaultValue: dto.defaultValue,
        isRequired: dto.isRequired,
        maxLength: dto.maxLength,
    };
};

export const mapSelectFormField = (dto: SelectFormFieldDTO): SelectFormField => {
    return {
        ...(mapBaseFormField(dto) as BaseField<FormFieldType.SELECT>),
        options: dto.options.map((option) => mapFormFieldSelectOption(option)),
    };
};
